import { encode, decode } from 'shopify-gid';

export const productEncode = (type, id) => {
  const encodedId = encode(type, id);
  return encodedId;
};

export const productDecode = (id) => {
  if (!id) return;

  // Localstorage products have been decoded, ContentStack data points aren't.
  // Because of this potential mix, we'll only actually decode if it's required,
  // otherwise we'll just return the proper ID
  if (id?.includes('gid://shopify/Product/')) {
    return { id: id.split('gid://shopify/Product/')[1] };
  }
  if (id?.includes('gid://shopify/ProductVariant/')) {
    return { id: id.split('gid://shopify/ProductVariant/')[1] };
  }
  const encodedId = decode(id);
  return encodedId;
};
